export const formatPrice = function (price, locale, decimals) {
  const appLocale = locale || window.appLocale;
  const useDecimal = typeof decimals !== 'undefined';
  decimals = useDecimal ? decimals : 2;

  if (typeof Intl !== 'undefined') {
     let formattedPrice = new Intl.NumberFormat(new Intl.Locale(appLocale.replace('_', '-')), {
      style: 'currency',
      currency: currency,
      maximumFractionDigits: decimals,
      minimumFractionDigits: decimals
    }).format(price)

    return useDecimal ? formattedPrice : formattedPrice.replace(/[.,]00$/, '');
  }

  let formattedPrice = price.toFixed(decimals);
  return useDecimal ? formattedPrice : formattedPrice.replace(/[.,]00$/, '');
};

export const normalizePriceToApp = function (amount, useNumberFormat = true) {
  if (!amount) {
    return 0;
  }

  if (!useNumberFormat) {
    return amount / 100;
  }

  return Number(amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1')) / 100;
}

export const normalizePriceToMysql = function (amount) {
  if (!amount) {
    return 0;
  }

  if (isNaN(amount)) {
    amount = Number.parse(amount);
  }

  return Math.round(amount * 100);
}

export const formatNumber = function (number) {
  if (typeof number === 'string') {
    return parseFloat(number);
  }
  let negate = false;
  if (typeof number === 'number') {
    if (number < 0) {
      number *= -1;
      negate = true;
    }
    number = Math.round(number * 100) / 100;
    if (negate) {
      number *= -1;
    }

    return number;
  }
  if (typeof number === 'object') {
    return 0;
  }
};

export const floatify = function (val) {
  if (val === null || val === '') {
    val = 0;
  }

  return parseFloat(val);
};
